import type { WorkspaceType } from './model';

export function isAutoCreateTabWorkspace(workspace: WorkspaceType) {
  switch (workspace) {
    case 'dynamic':
    case 'static':
    case 'newBatch':
    case 'essential':
      return true;
    case 'secondaryMarketPostEvents':
    case 'secondaryMarketQuotes':
    case 'postTrade':
      return false;
    default:
      return false;
  }
}
